import React from 'react';
import { bool, func } from 'prop-types';
import { useNavigate } from 'react-router-dom';

import ImageAccountSuspended from '@assets/Image/DayTrading/AccountSuspended.svg';

import { Container, Row, Col, Button, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const PopUpDtSuspended = (props) => {
  const { show, onHide } = props;

  const navigate = useNavigate();

  const handleMoreInfo = () => {
    navigate('/faq');
  };

  return (
    <PopUpCenterV2 size="md" show={show} onHide={onHide} data-testid="popup-dtSuspended">
      <img src={ImageAccountSuspended} alt="account-suspended" />
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          Day Trading Tidak Bisa Digunakan
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          Kunjungi Bantuan Ajaib untuk informasi lebih lanjut tentang Buying Power Day Trading kamu.
        </Typography>
      </Container>
      <Row gutters={8} align="between">
        <Col>
          <Button fluid variant="naked" size="lg" onClick={onHide}>
            Mengerti
          </Button>
        </Col>
        <Col>
          <Button fluid variant="primary" size="lg" onClick={handleMoreInfo}>
            Pelajari Lebih Lanjut
          </Button>
        </Col>
      </Row>
    </PopUpCenterV2>
  );
};

PopUpDtSuspended.propTypes = {
  show: bool,
  onHide: func,
};

PopUpDtSuspended.defaultProps = {
  show: false,
  onHide: () => {},
};

export default PopUpDtSuspended;
